/*
 * This file is a shallow port of edde/edde/constants/media_file.py
 */

// Video formats
export const WMV_256K_FORMAT_ID = 1;
export const MOV_256K_FORMAT_ID = 2;
export const MPG_FORMAT_ID = 3;
export const WMV_700K_FORMAT_ID = 11;
export const DRM_256K_FORMAT_ID = 12;
export const DRM_700K_FORMAT_ID = 13;
export const WMV_1MB_FORMAT_ID = 22;
export const MOV_1MB_FORMAT_ID = 23;
export const FLV_600K_FORMAT_ID = 24;
export const MPEG_FORMAT_ID = 33;
export const MP4_300K_FORMAT_ID = 34;
export const MP4_2MB_FORMAT_ID = 35;
export const WEBM_400K_FORMAT_ID = 42;

export const MP4_264K_FORMAT_ID = 54;
export const MP4_464K_FORMAT_ID = 55;
export const MP4_664K_FORMAT_ID = 56;
export const MP4_1296K_FORMAT_ID = 57;
export const MP4_3596K_FORMAT_ID = 58;
export const MP4_5128K_FORMAT_ID = 59;
export const MP4_6628K_FORMAT_ID = 60;
export const MP4_8628K_FORMAT_ID = 61;

export const VIDEO_FORMAT_IDS = [
  WMV_256K_FORMAT_ID,
  MOV_256K_FORMAT_ID,
  MPG_FORMAT_ID,
  WMV_700K_FORMAT_ID,
  DRM_256K_FORMAT_ID,
  DRM_700K_FORMAT_ID,
  WMV_1MB_FORMAT_ID,
  MOV_1MB_FORMAT_ID,
  FLV_600K_FORMAT_ID,
  MPEG_FORMAT_ID,
  MP4_300K_FORMAT_ID,
  MP4_2MB_FORMAT_ID,
  WEBM_400K_FORMAT_ID,
];

export const H264_VALID_VIDEO_FORMATS = [
  MP4_300K_FORMAT_ID,
  MP4_2MB_FORMAT_ID,
];

export const HLS_VIDEO_FORMAT_IDS = [
  MP4_264K_FORMAT_ID,
  MP4_464K_FORMAT_ID,
  MP4_664K_FORMAT_ID,
  MP4_1296K_FORMAT_ID,
  MP4_3596K_FORMAT_ID,
  MP4_5128K_FORMAT_ID,
  MP4_6628K_FORMAT_ID,
  MP4_8628K_FORMAT_ID,
];

// Captions file
export const SMI_CLOSED_CAPTION_FILE_FORMAT_ID = 14;
export const VTT_FORMAT_ID = 52;

// Documents
export const TEACHER_GUIDE_FORMAT_ID = 6;
export const DOC_GENERAL_DOC_FORMAT_ID = 7;
export const PDF_FORMAT_ID = 8;
export const PDF_NOT_A_RELATED_ITEM_FORMAT_ID = 20;
export const DOC_WORD_DOCUMENT_FORMAT_ID = 21;
export const PPT_POWER_POINT_PRESENTATION_FORMAT_ID = 31;
export const XLS_EXCEL_WORK_SHEET_FORMAT_ID = 39;
export const PDF_CORRELATION_DOCUMENT_FORMAT_ID = 40;
export const PDF_PDF_VERSION_FORMAT_ID = 51;

// Images
export const GIF_JPG_PNG_GENERAL_IMAGE = 9;

export const SMALL_IMAGES = 36;
export const MEDIUM_IMAGES = 37;
export const LARGE_IMAGES = 38;

export const MAP_IMAGE_BASE = 44;
export const MAP_IMAGE_OVERLAY = 45;

// Mobile
export const MOBILE_CARD_HANDHELD_FORMAT_ID = 47;
export const MOBILE_CARD_TABLET_FORMAT_ID = 48;
export const MOBILE_BANNER_HANDHELD_FORMAT_ID = 49;
export const MOBILE_BANNER_TABLET_FORMAT_ID = 50;

// Audio
export const MP3_GENERAL_AUDIO_FORMAT_ID = 16;
export const OGV_300K_OGG_FORMAT_ID = 41;

// Other
export const SWF_INTERACTIVE_FILES_FORMAT_ID = 17;
export const HTML_FORMAT_ID = 32;
export const HTML_5_FORMAT_ID = 43;
export const CFM_ASP_SERVER_SIDE_SCRIPTS_FORMAT_ID = 46;
export const M3U8_PLAYLIST_FORMAT_ID = 53;
